module.exports = require("./eo.d.ts");